import type { Language } from "@/src/common/locales/i18n";
import legalNoticesEn from "@/src/legal/locales/en/legal-notices.md?raw";
import privacyEn from "@/src/legal/locales/en/privacy.md?raw";
import termsEn from "@/src/legal/locales/en/terms.md?raw";
import legalNoticesEs from "@/src/legal/locales/es/legal-notices.md?raw";
import privacyEs from "@/src/legal/locales/es/privacy.md?raw";
import termsEs from "@/src/legal/locales/es/terms.md?raw";

const LEGAL_DOCUMENTS = {
	privacy: "privacy",
	terms: "terms",
	legal_notices: "legal_notices",
} as const;

export type LegalDocumentKey = keyof typeof LEGAL_DOCUMENTS;

export const LEGAL_MARKDOWN: Record<Language, Record<LegalDocumentKey, string>> = {
	en: {
		privacy: privacyEn,
		terms: termsEn,
		legal_notices: legalNoticesEn,
	},
	es: {
		privacy: privacyEs,
		terms: termsEs,
		legal_notices: legalNoticesEs,
	},
};
